const messages = {
    ch: {
        account: {
            account_settings: '帳號設定',
            change_email: '更改電子郵件',
            change_email_info: '請在下方輸入新電子郵件。<br>我們將發佈一封電子郵件驗證信。',
            delete_account: '刪除帳號',
            delete_account_info: {
                header: '這將永久刪除您的帳號和個人資料。',
                body: '將被刪除的資訊包括:',
                list: [
                    '您的個人資訊',
                    '在我們系統內申請的工作（非包括雇主可能已經下載的資訊）)',
                    '履歷，包含雇主搜尋的',
                    '營銷和工作提醒的電郵訂閱',
                ],
                footer: '之後，您將能創建一個新帳號。',
            },
            delete_confirmation: '您確定嗎？此行為無法復原。',
            delete_success_title: '我們對您的離開感到相當遺憾',
            delete_success_message: '您的帳號已經成功刪除。我們現在將把您登出。',
            enter_code: '輸入驗證碼',
            resend_code: '點擊以重新發送驗證碼',
            reset_password: '重設密碼',
            reset_password_info: '點擊下方按鈕後，我們將寄送重設密碼的驗證碼。系統將會提示您創建新的密碼！',
            reset_password_success: '我們已將重設碼發佈到您現在的電子郵件。請也確認您的垃圾信箱。點擊以重新發佈驗證碼。',
            try_again: '請10分鐘後再試',
        },

        api_message: {
            UserTokenNotFoundException: '此金鑰無效。',
            ValidationCaptchaException: '機器人驗證無效。',
            ValidationException: '部分內容似乎無效。',
            InvalidAuthenticationException: '請檢查您的電子郵件或密碼，然後再試一次。',
            MaxAttemptsException: '已超過嘗試次數。',
            ResourceNotFoundException: '未找到請求。',
            UserNotFoundException: '找不到用戶。',
            SeekerNotFoundException: '無效電子郵件。請檢查並再試一次。',
            SeekerEmailResetNotFoundException: '找不到您的電子郵件。',
            EmailTokenNotValidException: '此金鑰已過期或無效。',
            QueryException: '某處出了問題。',
            ServerErrorException: '某處出了問題。',
            UserConfirmationTokenNotFoundException: '此令牌似乎無效。',
            UserExistsException: '此電子郵件已被使用。',
            JobNotFoundException: '這個職位似乎已不再提供。',
            UserResumeNotFoundException: '這份履歷已不再存在。',
            UserJobAlertNotFoundException: '這個工作提醒似乎已不再存在。',
            UserAppliedForJobException: '您似乎已申請了這個職位。',
            PromotionNotFoundException: '這個推廣活動似乎不存在。.',
            SmartfeedJobTokenNotFoundException: '申請令牌無效。',
            InvalidPasswordException: '密碼無效。',
            OwnEmailNotAllowedException: '您無法更改目前的電子郵件。',
            FileImageSizeException: '圖片太小。最小尺寸為150x150像素。',
            FileSizeException: '檔案太大。檔案大小最大為20MB',
            GoogleCaptchaException: '無法驗證機器人驗證。',
            SeekerPasswordResetNotFoundException: '請重新輸入重設碼並再試一次。.',
            InvalidFilterCriteria: '太過廣泛。請列出更詳細的條件。',
            PasswordResetTooManyAttempts: '重設密碼次數太多。請20秒後再試。',
            PasswordTokenNotValid: '此令牌似乎已過期或無效。',
        },

        additional_document: {
            drag_and_drop_info: '拖放或點擊 <br> 以上傳附加文件',
            file_type_info: '上傳檔案僅限 .docx, .doc, .pdf',
            max_document_size_info: '履歷最大限10MB',
            not_found: '尚無儲存附加文件',
            remove: '刪除附件？',
            title: '附件',
            uploaded: '已上傳',
            uploaded_documents: '已上傳的檔案',
        },

        application: {
            title: '申請',
            not_found: '未找到申請紀錄',
            view: '查看工作',
        },

        apply: {
            apply_with_email_title: '或用您的電子郵件申請',
            apply_for_job: '申請工作',
            apply_as_guest: '作為訪客申請',
            info: '我們將從您選擇申請的帳戶自動創建個人檔案',
            apply_with_email: '透過電子郵件申請',
            apply_with_linkedin: '用 Linkedin 申請',
            back: '返回職缺頁面',
            confirmation: '確認電郵已發送至',
            job_application: '工作申請',
            loading_resume: '正在載入您的履歷。請稍等..',
            success: '感謝您申請此工作',
            title: '使用帳號申請',
            register_and_apply: '註冊並申請',
            application_already_received: '已收到申請',
        },

        cover_letter: {
            add: '新增求職信',
            apply_without: '不帶求職信申請',
            drag_and_drop_info: '拖放或點擊 <br> 以上傳求職信',
            edit: '編輯求職信',
            file_type_info: '檔案僅限 .docx, .doc, .pdf',
            max_document_size_info: '履歷最大限10MB',
            not_found: '尚未儲存求職信',
            remove: '刪除求職信？',
            title: '求職信',
            uploaded: '已上傳',
            uploaded_documents: '已上傳的求職信',
            write_new: '撰寫新的求職信',
        },

        dashboard_menu: {
            applications: '申請',
            saved_jobs: '已儲存的工作',
            job_alerts: '工作提醒',
            profile_details: '個人檔案',
            work_preferences: '工作偏好',
            documents: '文件',
            account_settings: '帳號設定',
            logout: '登出',
        },

        filter: {
            clear_all: '全部清除',
            info: '使用者搜尋欄以查看更多',
            see_less: '查看更少',
            see_all_value: '查看所有 {值} 的篩選器',
        },

        forgot_password: {
            title: '忘記密碼',
            info: '請輸入您的電子郵件。我們將寄送重設密碼的驗證碼給您。',
            resend_code: '點擊以重新發佈驗證碼',
            success: '我們已將重設碼寄到下方的電子郵件。請確保也檢查您的垃圾信箱。',
            success_resend_code: '我們已將重設碼寄到下方的電子郵件。請確保也檢查您的垃圾信箱。',
            try_again: '請數秒後再試',
        },

        create_password: {
            title: '建立密碼',
            info: '歡迎回來！您的密碼已經過期了。我們已給您發佈了一個重設密碼的驗證碼。請在下方輸入您的驗證碼並重設您的密碼。',
        },

        global: {
            currency_format: '${0}',
            currency_symbol: '$',
        },

        job_alert: {
            create: '設定工作提醒',
            error: '無法建立您的工作提醒，請刷新並再試一次。',
            manage: '管理您的工作提醒',
            not_found: '找不到儲存的工作提醒',
            remove: '刪除此工作提醒？',
            save: '儲存工作提醒',
            saved: '已儲存的工作提醒',
            search_term: '搜尋欄',
            success: '您的工作提醒已建立，謝謝',
            success_remove: '您的工作提醒已刪除，謝謝',
            title: '工作提醒',
        },

        job_view: {
            date_posted: '發佈日期',
            expired: '此工作已過期',
            expired_desc: '此工作已不再徵才。請點擊 \'查看更多結果\' 瀏覽我們的完整職位列表。',
            posted_on: '發布於',
            see_desc: '查看工作描述',
            hide_desc: '隱藏工作描述',
            other_jobs: '相似工作',
        },

        label: {
            any: '任何',
            add_all: '加入所有您有興趣的',
            add_value: '加入',
            alert_name: '提醒名稱',
            alert_name_placeholder: '輸入搜尋名稱',
            annual_salary: '年薪',
            annualy: '每年',
            any_value: '任何 {值}',
            applied: '已申請',
            apply_now: '立即申請',
            apply_again: '再次申請',
            apply_as_guest: '作為訪客申請',
            availability: '可用性',
            back: '返回',
            back_to_value: '回到 {值}',
            base_pay: '基本工資',
            cancel: '取消',
            career_level: '職業等級',
            consultant: '顧問',
            certifications: '證書',
            change_email: '更改電子郵件',
            classification: '分類',
            classification_select: '從下方選擇分類',
            sub_classification_select: '選擇次分類',
            company: '公司',
            company_placeholder: '輸入公司名稱，例如：ALDI Australia',
            company_size: '公司規模',
            confirm_password: '確認密碼',
            confirm_remove: '是的，刪除',
            contact_number: '聯繫電話',
            contact_number_placeholder: '輸入聯絡電話',
            country: '國家',
            country_of_citizenship: '是否具有該國公民身分',
            phone_number: '電話號碼',
            phone_number_placeholder: '輸入電話號碼',
            mobile_number: '手機號碼',
            mobile_number_placeholder: '輸入手機號碼',
            contract_type: '派遣類型',
            course_name: '課程名稱',
            cover_letter: '求職信',
            cover_letter_name: '求職信名稱',
            cover_letter_custom_name: '輸入求職信名稱',
            create: '建立',
            create_password: '建立密碼',
            create_job_alert: '建立工作提醒',
            current_role: '目前職位',
            daily: '每日',
            date_posted: '發佈日期',
            delete_my_account: '刪除帳號',
            description: '說明',
            desired_occupations: '期望職位',
            desired_pay: '期望薪酬',
            desired_work_locations: '期望工作地點',
            dont_have_account: '沒有帳號？',
            already_have_account: '已有帳號？',
            dob: '出生日期',
            download: '下載',
            edit: '編輯',
            edit_value: '編輯 {值}',
            education: '教育程度',
            email: '電子郵件',
            email_address: '電郵地址',
            email_address_placeholder: '輸入電子郵件',
            email_to: '寄送至',
            email_me_code: '通過電子郵件寄送驗證碼',
            email_alert_frequency: '電子郵件提醒頻率',
            null_pay_included: '包括沒有薪資詳情的工作',
            is_report_directly: '你是否直接向這位推薦人報告?',
            is_contactable: '我們可以聯繫這位推薦人嗎？',
            end_date: '結束日期',
            enter_code: '輸入驗證碼',
            enter_your_value: '輸入您的 {值}',
            enter_your_value_again: '再次輸入您的 {值}',
            enter_the_value: '輸入 {值}',
            enter_value: '輸入 {值}',
            enter_current_password: '輸入目前密碼',
            enter_current_password_for_email: '輸入目前密碼以驗證電子郵件更改',
            enter_new_email: '輸入新電子郵件',
            enter_new_password: '輸入新密碼',
            expires_at: '截止日期',
            frequency: '頻率',
            first_name: '名字',
            first_name_placeholder: '輸入名字',
            position: '職位',
            position_placeholder: '輸入職位',
            filters: '篩選條件',
            forgot_password: '忘記密碼',
            gender: '性別',
            go: '設定薪資',
            home_location: '家庭所在地',
            hourly: '時薪',
            hourly_rate: '每小時工資',
            institution_name: '機構名稱(學校名稱)',
            industries: '您有興趣的行業',
            in_progress: '進行中',
            job_mode: '工作模式',
            job_title: '職位名稱',
            job_title_placeholder: '輸入您的職位名稱，例如：會計師',
            job_type: '工作類型',
            job_type_placeholder: '選擇一種工作類型',
            keyword: '關鍵字',
            last_name: '姓氏',
            last_name_placeholder: '輸入姓氏',
            languages: '語言',
            licenses_and_certifications: '證書及證照',
            licenses_or_certifications: '證書或證照',
            location: '地點',
            login: '登入',
            select_location: '所有地點',
            max: '最大',
            message: '訊息',
            modified: '已修改',
            min: '最小',
            new_cover_letter_details: '新求職信詳情',
            no_industries: '我對產業沒有偏好',
            no_job_mode: '我對工作模式沒有偏好',
            not_found: '未找到',
            not_added_value: '沒有加入',
            occupation: '職業',
            occupation_placeholder: '加入所有您感興趣的職業',
            work_occupation_placeholder: '輸入您的工作職業',
            off: '關閉',
            password: '密碼',
            placeholder_email: '電子郵件',
            placeholder_password: '密碼',
            payband_placehoder: '選擇最接近值',
            per_day: '每天',
            perks_and_benefits: '薪資與福利',
            profession: '專業',
            recover_password: '找回密碼',
            reference_number: '推薦碼',
            relevance: '相關性',
            reset: '重設',
            reset_password: '重設密碼',
            print: '列印',
            profile_picture: '個人照片',
            qualification_type: '資格類型',
            range: '範圍',
            register: '註冊',
            required_value: '{值} 欄位為必填',
            remove: '刪除',
            salary: '薪資',
            salary_type: '薪資類型',
            save: '儲存',
            save_cover_letter: '儲存求職信',
            save_job: '儲存職位',
            save_value: '儲存 {值}',
            save_work_experience: '儲存工作經驗',
            search_jobs: '搜尋',
            search_keyword: '輸入關鍵字',
            search_within_value: '`在 {值1} {值2} 中搜尋',
            sector: '產業',
            search_by_location: '按照郊區，城市或區域搜尋',
            select_value: '選擇 {值}',
            start_date: '開始日期',
            sort_by: '排序方式',
            sign_in: '登入',
            sign_in_and_apply: '登入並申請',
            continue_to_apply: '繼續申請',
            skills: '技能',
            share: '分享',
            start_end_dates: '開始和結束日期',
            sub_classification: '次分類',
            suburb_city_area: '郊區，城市或區域',
            unsave: '取消儲存',
            upload_new_resume: '上傳新履歷',
            upload_new_cover_letter: '上傳新求職信',
            upload_new_additional_document: '上傳新附件',
            upload_profile_picture: '上傳個人照片',
            uploaded_document: '已上傳文件',
            upload_label: '點擊上傳文件',
            upload_file_size: '文件最大限10MB',
            uploaded: '已上傳',
            uploaded_now: '剛剛',
            upload_new: '上傳新內容',
            view_job: '查看職位',
            weekly: '每週',
            what_is_this: '這是什麼',
            what_is_this_occupation: '該職業將為您客製化工作建議。請選擇與職務最相關的職業。',
            work_authorisation: '就業許可',
            work_experience: '工作經驗',
            work_location: '工作地點',
            work_preferences: '工作偏好',
            reference: '推薦信',
            work_type: '工作類型',
            write_cover_letter: '撰寫求職信',
            write_a_cover_letter: '撰寫求職信',
            resumes: '履歷',
            cover_letters: '求職信',
            additional_documents: '附加文件',
            find_jobs_now: '立即找工作',
            basic_information: '基本資訊',
            look_for_all_jobs: '尋找所有應徵中的工作',
            emergency_contact_name: '緊急聯絡人姓名',
            emergency_contact_number: '緊急聯絡人電話號碼',
            emergency_contact_rel: '緊急聯絡人關係',
            submit: '提交',
        },

        login: {
            welcome_back: '歡迎回來',
            welcome: '歡迎！',
            title: '登入',
            info: '',
            back: '回到登入',
        },

        profile: {
            basic_information: '基本資訊',
            not_found_location: '目前不支援此地區的職缺列表。若需搜尋此地區，請與聯絡我們。',
            not_found_global_location: '找不到符合地點。請嘗試不同的搜尋，或者選擇國家作為地點。',
            pay_info: '您的薪資狀況有助於我們更了解您的工作歷程，使我們能更快了解整體狀況，協助您的職涯發展。',
            profile_details: '個人檔案詳情',
        },

        register: {
            welcome: '歡迎',
            welcome_aboard: '歡迎加入！',
            info: '',
            back: '回到註冊頁面',
        },

        reset_email: {
            title: '重設電子郵件',
            success: '您的電子郵件已重設',
        },

        reset_password: {
            title: '建立密碼',
            info: '請輸入您帳號的電子郵件和新密碼。',
            success: '您已成功創建新密碼！',
        },

        resume: {
            apply_without: '直接申請',
            default: '預設履歷',
            dropbox_title: '透過 Dropbox 上傳',
            default_option: '做為未來申請時的選項',
            default_text: '選擇履歷',
            drag_and_drop_info: '拖放或點擊 <br> 上傳履歷',
            drag_and_drop_size: '（檔案最大限10MB）',
            file_type_info: '僅限pdf, docx, doc, rtf, txt, odt, pages（最大10MB）',
            googledrive_title: '透過 Google Drive 上傳',
            max_resume_size_info: '上傳履歷檔案大小，最大為10MB',
            new: '上傳新履歷',
            not_found: '尚無履歷上傳',
            remove: '刪除履歷？',
            title: '履歷',
            upload_documents: '上傳附件',
            upload: '上傳履歷',
            uploaded: '已上傳',
            uploaded_resumes: '選擇履歷',
            upload_via: '透過{}上傳',
            document_uploaded: '文件已上傳',
        },

        saved_job: {
            saved_jobs: '已儲存工作',
            not_found: '未找到已儲存工作',
        },

        search_results: {
            not_found: '抱歉，目前沒有任何符合您搜尋條件的工作機會。請點擊上方職缺提醒按鈕，我們將在有符合條件的職缺開啟時通知您。',
            showing: '顯示',
            separator: '到',
            of: '的',
            results: '結果',
            listView: '查看列表',
            mapView: '查看地圖',
            mapViewLocation: '街道地址/郵遞區號',
            mapViewRadius: '在（公里）內',
            mapViewUpdate: '更新地圖',
            mapViewReset: '重設地圖',
        },

        share: {
            facebook: '發佈',
            linkedin: '分享',
            title: '透過...分享',
            twitter: '轉推',
        },

        terms: {
            link: '若繼續申請，即代表同意我們的......',
            terms: '使用條款',
            and: '以及',
            privacy: '隱私政策',
            validation_message: '請同意我們的條款和條件',
        },

        work_preferences: {
            work_preferences: '工作偏好',
            next_role: '您的下一個職位',
            other: '其他偏好',
            job_type: '工作類型',
            contract_type: '合約類型',
        },

        work_experience: {
            add: '新增工作經驗？',
            edit: '編輯工作經驗？',
            remove: '刪除工作經驗',
        },

        single_job: {
            backToSearchUrl: '職位',
            see_more_results: '查看更多結果',
            see_more_results_2: '返回所有機會',
        },

        education: {
            add: '新增學歷',
            remove: '刪除學歷',
        },

        reference: {
            add: '新增推薦人',
            remove: '刪除推薦人',
        },

        searchbar: {
            keywords_label: '關鍵字',
            classifications_label: '分類',
            classification_placeholder: '在所有分類中',
            locations_label: '位置',
        },

        screening: {
            confirm_and_finish: '確認並完成',
            title: '完成額外問題',
            sub_title: '完成以下問題以提升您被考慮此職位的機會',
        },

        networks: {
            facebook: {
                shareText: '發佈',
            },
            twitter: {
                shareText: '轉推',
            },
            linkedin: {
                shareText: '分享',
            },
        },
    },
};

export default messages;
